"use client"

import CommonTitle from "@/ui/common/bit/CommonTitle"
import BlockWrapper from "@/ui/common/BlockWrapper"
import FiltersWrapper from "@/ui/FiltersWrapper/FiltersWrapper"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { colors, mediaQueries, sizes } from "ui"

export const StyledBlockWrapper = styled(BlockWrapper)`
  gap: ${sizes.baseQuadric};
  padding-left: ${sizes.baseSingle};
  padding-right: ${sizes.baseSingle};
  ${mediaQueries.desktopM} {
    padding-left: ${sizes.baseSingle};
    padding-right: ${sizes.baseSingle};
    gap: 40px;
  }
  ${mediaQueries.desktopXl} {
    padding-left: 0;
    padding-right: 0;
    gap: 40px;
  }
`

export const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${sizes.baseQuadric};

  ${mediaQueries.desktopM} {
    align-items: center;
    justify-content: space-between;
    gap: 40px;
  }
`

export const StyledFiltersWrapper = styled(FiltersWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: inherit;
  width: 100%;
`

export const StyledFormTitles = styled(CommonTitle)`
  align-items: center;
  text-align: center;
  gap: ${sizes.baseDouble};
`

export const StyledResultsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const StyledResultsNumber = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: ${sizes.baseDouble} 0;
  width: 100%;
  text-align: start;
  font-size: 14px;
  color: ${colors.black};

  ${mediaQueries.desktopM} {
    font-size: 16px;
  }
`
